const brandingLabels = {
	abo: 'Abo & Angebote',
	about: 'Unternehmen',
	editorialweb: 'Der Standard',
	immobilien: 'Immobilien',
	jobs: 'Jobs',
	livecontent: 'Der Standard',
	userprofile: 'Der Standard',
};

export { brandingLabels };
